/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { useCallback } from 'react';

import classNames from 'classnames';
import { useDispatch } from 'react-redux';

import { icons } from '../../../assets';
import { ImgStyled } from '../../../components/common/Block/Img';
import { modalOpen } from '../../modal/modalActions';
import FormAddress, { IFormAddressProps } from './FormAddress';
import { FormAddressOpenIconStyled } from './styled/FormAddressStyled';

interface IFormAddressOpenIcon extends IFormAddressProps {
    isDisabled: boolean;
}

const FormAddressOpenIcon = ({ isDisabled, initialize, onSubmit, type }: IFormAddressOpenIcon) => {

    const dispatch = useDispatch();

    const onClickHandler = useCallback(() => {
        if (!isDisabled) {
            dispatch(modalOpen({
                render: props => <FormAddress
                    {...props}
                    initialize={initialize}
                    type={type}
                    onSubmit={onSubmit}
                />,
            }));
        }
    }, [dispatch, isDisabled, initialize, onSubmit, type]);

    return (
        <FormAddressOpenIconStyled
            className={classNames('form-address__icon', { disabled: isDisabled })}
            onClick={onClickHandler}
        >
            <ImgStyled className="medium" src={isDisabled ? icons.editDisabledIcon : icons.editGreenIcon}/>
        </FormAddressOpenIconStyled>
    );
};

export default FormAddressOpenIcon;
